import React from "react";
import './pp.css'

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container policy-page" style={{ padding: "2rem" }}>
       <h1>Privacy Policy for Education Consultancy</h1>
      <p>Last Updated: {new Date().getFullYear()}</p>

      <p>
        Nova EduBridge (“we”, “our”, or “us”) is committed to protecting the
        privacy of students, parents, and users who interact with our services.
        This Privacy Policy explains how we collect, use, and safeguard your
        information when you contact us, visit our website, or use our study
        abroad counselling services.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li>Personal Information: Name, email, phone number, address.</li>
        <li>Academic Details: Past education records, scores, preferences.</li>
        <li>Documents: Passport, ID proofs, transcripts, resume/CV.</li>
        <li>Website Usage Data: IP address, browser type, visited pages.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <p>We use the collected data to:</p>
      <ul>
        <li>Provide study abroad counselling and career guidance.</li>
        <li>Assist with university applications and visa processes.</li>
        <li>Communicate important updates and educational opportunities.</li>
        <li>Improve our services and website user experience.</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>
        We do not sell or rent your personal information. Your data may be shared
        only with:
      </p>
      <ul>
        <li>Universities, colleges, and partner institutions.</li>
        <li>Embassies/visa authorities when required.</li>
        <li>Legal authorities if required by law.</li>
      </ul>

      <h2>Data Security</h2>
      <p>
        We take all necessary security measures to protect your data from
        unauthorized access, loss, or misuse. However, no online data
        transmission can be guaranteed 100% secure.
      </p>

      <h2>Your Rights</h2>
      <ul>
        <li>Request access to your stored data.</li>
        <li>Request corrections or updates to your information.</li>
        <li>Request removal of your data (subject to legal requirements).</li>
      </ul>

      <h2>Contact Us</h2>
      <p>Email: info@novaedubridge.com</p>
      <p>
        Office: No.121, 1st Floor, Eshwar Plaza, 4th Main Road, 1st Phase, 1st
        Stage, Manjunatha Nagar, West of Cord Road, Bangalore - 560010.
      </p>
      <p>Phone: +91 99020 43004</p>

      <p>
        By using our website and services, you agree to this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
